<template>
  <!-- Dialog Complete Step -->
  <ib-dialog
    :visible="visible"
    :closable="false"
    width="400px"
    top="8vh"
    empty-header
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/complete-step.svg')"
      :title="$t('dialogs.completeStep.title')"
      :subtitle="$t('dialogs.completeStep.description')"
    />

    <!--    <div class="text-wrapper text-center">-->
    <!--      <p class="m-0">-->
    <!--        {{ $t('dialogs.completeStep.subtitleFirst') }}-->
    <!--      </p>-->
    <!--      <p class="m-0">-->
    <!--        {{ $t('dialogs.completeStep.subtitleFirst') }}-->
    <!--      </p>-->
    <!--    </div>-->
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :submit-btn-text="$t('confirm')"
        :cancel-btn-text="$t('cancel')"
        @cancel="closeDialog"
        @submit="completeStep"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Complete Step -->
</template>

<script>
export default {
  name: 'DialogCompleteStep',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    },

    completeStep () {
      this.$emit('complete-step')
    }
  }
}
</script>
<style scoped lang="scss">
.text-wrapper {
  p {
    font-size: 1.5rem;
    opacity: 0.5;
  }
}
</style>
